import { defineMessages } from 'react-intl'

const translations = defineMessages({
  HEIDELPAY_PAYPAL: {
    defaultMessage: 'Paypal',
    id: 'msp.account_payment_methods.title.paypal'
  },
  HEIDELPAY_DIRECT_DEBIT: {
    defaultMessage: 'Direct Debit',
    id: 'msp.account_payment_methods.title.direct_debit'
  },
  HEIDELPAY_INVOICE: {
    defaultMessage: 'Pay by Invoice',
    id: 'msp.account_payment_methods.title.invoice'
  },
  HEIDELPAY_CREDIT_CARD: {
    defaultMessage: 'Credit Card ({cardType})',
    id: 'msp.account_payment_methods.title.credit_card'
  },
  MASTER: {
    defaultMessage: '(Mastercard)',
    id: 'msp.account_payment_methods.title.master_card'
  },
  VISA: {
    defaultMessage: '(Visa)',
    id: 'msp.account_payment_methods.title.visa_card'
  },
  creditCardNumber: {
    defaultMessage: 'Card Number: {number}',
    id: 'msp.account_payment_methods.credit_card.number'
  },
  creditCardValidity: {
    defaultMessage: 'Valid till: {expiryDate}',
    id: 'msp.account_payment_methods.credit_card.validity'
  },
  creditCardExpired: {
    defaultMessage: 'Expired',
    id: 'msp.account_payment_methods.credit_card.expired'
  },
  bankAccountNumber: {
    defaultMessage: 'Account Number: {number}',
    id: 'msp.account_payment_methods.bank_account.account_number'
  },
  iban: {
    defaultMessage: 'IBAN: {number}',
    id: 'msp.account_payment_methods.bank_account.iban'
  },
  bankRoutingNumber: {
    defaultMessage: 'BIC/SWIFT: {number}',
    id: 'msp.account_payment_methods.bank_account.routing_number'
  },
  payPayEmail: {
    defaultMessage: 'PayPal email: {paypalEmail}',
    id: 'msp.account_payment_methods.paypal.email'
  },
  invoicedTo: {
    defaultMessage: 'Billing Address:',
    id: 'msp.account_payment_methods.invoice.billing_address'
  },
  invoicedToBirthday: {
    defaultMessage: 'Birthday: {birthDay}',
    id: 'msp.account_payment_methods.invoice.birthday'
  },
  paymentNote: {
    defaultMessage:
      'Note: You must enter your Paypal log in details when you place an order.',
    id: 'msp.account_payment_methods.note.description'
  }
})

export default translations
